// USD cost formatting. The backend is the single source of truth for
// inference cost: it computes ``cost_usd`` on every spend row from the
// token counts + model_id via its pricing module (see
// src/inrange_agents/pricing.py). The FE no longer computes price - it
// only formats the backend's ``cost_usd``. Currency is USD only; there
// is no GBP conversion anywhere in the platform.
//
// ``null`` / ``undefined`` (model not in the BE price table, or a row
// pre-dating token capture) renders as "$?" so we never quote a wrong
// number.

export const formatUsd = (usd: number | null | undefined): string => {
  if (usd == null) return "$?";
  if (usd <= 0) return "$0.00";
  if (usd < 0.01) return "<$0.01";
  if (usd < 1000) return `$${usd.toFixed(2)}`;
  return `$${Math.round(usd).toLocaleString("en-GB")}`;
};
